module.exports = __webpack_public_path__ + "media/images/logo-ba46ab325d287196f952d1dc4c10b2a0.png";